import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ZenithModalVariant } from '../zenith/zenith.types';
import { ActionModal } from './action-modal.component';

@Component({
  selector: 'qpc-confirmation-modal',
  imports: [ActionModal, TranslateModule, ZenithComponentsModule],
  template: `
    <qpc-action-modal
        [heading]="heading()"
        [variant]="variant()"
        [actionButtonLabel]="actionButtonLabel()"
        [cancelButtonLabel]="cancelButtonLabel()"
        (onAction)="onAction.emit()"
        (onCancel)="onCancel.emit()">

      <p>{{ text() | translate }}</p>

    </qpc-action-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ConfirmationModal {
  readonly heading = input.required<string>();
  readonly text = input.required<string>();
  readonly variant = input<ZenithModalVariant>('small');
  readonly actionButtonLabel = input<string>('components.zenith.action-modal.confirm');
  readonly cancelButtonLabel = input<string>('components.zenith.action-modal.cancel');

  readonly onAction = output();
  readonly onCancel = output();

}
